<template>
  <v-container class="ma-0 pa-0">
    <poll-discussion
      :questionID="questionID"
      :getQuestionFunc="getQuestionFunc"
      :getPollFunc="getPollFunc"
      :getCommentsFunc="getCommentsFunc"
      :createCommentFunc="createCommentFunc"
      :updateCommentFunc="updateCommentFunc"
      :deleteCommentFunc="deleteCommentFunc"
      :voteUpCommentFunc="voteUpCommentFunc"
      :voteDownCommentFunc="voteDownCommentFunc"
      :readCommentFunc="readCommentFunc"
      :createCommentAttachmentFormDataFunc="createCommentAttachmentFormDataFunc"
      :createCommentAttachmentFunc="createCommentAttachmentFunc"
      :updateCommentAttachmentFormDataFunc="updateCommentAttachmentFormDataFunc"
      :updateCommentAttachmentFunc="updateCommentAttachmentFunc"
      :deleteCommentAttachmentFunc="deleteCommentAttachmentFunc"
    ></poll-discussion>
  </v-container>
</template>
<script>
import PollDiscussion from "@/components/poll/discussion/PollDiscussion.vue";
import { APIService } from "@/http/APIService.js";

const apiService = new APIService();

export default {
  components: {
    PollDiscussion
  },

  computed: {
    questionID() { return parseInt(this.$route.params.questionID) }
  },

  methods: {
    getQuestionFunc(id) {
      return apiService.getReferendumQuestion(id);
    },

    getPollFunc(id) {
      return apiService.getReferendumQuestion(id);
    },

    getCommentsFunc(sort, search, limit, offset, filter) {
      return apiService.getReferendumQuestionComments(sort, search, limit, offset, filter);
    },

    createCommentFunc(item) {
      return apiService.createReferendumQuestionComment(item);
    },

    updateCommentFunc(item) {
      return apiService.updateReferendumQuestionComment(item);
    },

    deleteCommentFunc(id) {
      return apiService.deleteReferendumQuestionComment(id);
    },

    voteUpCommentFunc(id) {
      return apiService.referendumQuestionCommentVoteUp(id);
    },

    voteDownCommentFunc(id) {
      return apiService.referendumQuestionCommentVoteDown(id);
    },

    readCommentFunc(id) {
      return apiService.referendumQuestionCommentRead(id);
    },

    createCommentAttachmentFormDataFunc(data) {
      return apiService.createReferendumQuestionCommentAttachmentFormData(data);
    },

    createCommentAttachmentFunc(data) {
      return apiService.createReferendumQuestionCommentAttachment(data);
    },

    updateCommentAttachmentFormDataFunc(data) {
      return apiService.updateReferendumQuestionCommentAttachmentFormData(data);
    },

    updateCommentAttachmentFunc(data) {
      return apiService.updateReferendumQuestionCommentAttachment(data);
    },

    deleteCommentAttachmentFunc(data) {
      return apiService.deleteReferendumQuestionCommentAttachment(data);
    },
  }
}
</script>